import { isYouTubeUrl, getYouTubeEmbedUrl } from '@shared/utils/videoUtils'

/**
 * 活動影音播放 Modal（YouTube 或直接影片網址）
 */
export default function ExpoVideoModal({ video, onClose }) {
  if (!video?.media_url) return null

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="fixed top-4 right-4 z-[10000] w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full border-2 border-white/30 text-white transition-all"
      >
        <span className="material-symbols-outlined text-2xl">close</span>
      </button>
      <div className="relative w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
        <div className="relative aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl">
          {isYouTubeUrl(video.media_url) ? (
            <iframe
              src={`${getYouTubeEmbedUrl(video.media_url)}?autoplay=1&rel=0&modestbranding=1`}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full border-0"
            />
          ) : (
            <video
              src={video.media_url}
              controls
              autoPlay
              playsInline
              controlsList="nodownload"
              onContextMenu={(e) => e.preventDefault()}
              className="absolute inset-0 w-full h-full"
            />
          )}
        </div>
      </div>
    </div>
  )
}
